// import assign from 'lodash/assign';
import * as actionTypes from '../constants/actionTypes';
import {ActionTypes as customerActionTypes} from '../actions/customers.js';
import _ from 'lodash';
import {List} from 'immutable';

// import * as editorNames from '../constants/editorNames';

const initialState = {
  stones: [],
  fabricatorStones: [],
  masterStoneListIds: [],
  fabricatorCustomFilterIds: [],
  masterFilterIds: [],
  selectableFilterIds: [],
  filterGroupLookupTable: [],
  filterGroups: [],
  selectedFilters: [],
  usedFilterGroups: [],
  updates: [],
  usedFilterIds: []
};

const sortBy = (array, prop) => {
  array.sort((a, b) => {
    let aProp = _.trim(a[prop]).toLowerCase(),
        bProp = _.trim(b[prop]).toLowerCase();
    if(aProp < bProp)
      return -1;
    if(bProp < aProp)
      return 1;
    return 0;
  });
}

function setStones(state, action) {
  const {fabricator, filterGroups, fabricatorFilterIds, siteAdminFilterIds} = action.payload[0];
  state.stones = fabricator.stoneSupplierStones.stones;
  state.fabricatorStones = fabricator.stoneSupplierStones.stoneSupplierStones;
  state.masterStoneListIds = fabricator.masterStoneListIds;
  state.masterFilterIds = siteAdminFilterIds;
  state.fabricatorCustomFilterIds = fabricatorFilterIds;
  state.selectableFilterIds = _.uniq(_.concat(siteAdminFilterIds, fabricatorFilterIds));
  state.selectableFilterIds.sort((a,b) => a - b); //sorting *appears* unnecessary, but processor branch prediction can benefit greatly from the values being in order
  state.usedFilterIds = getUsedFilterIds(state.stones);
  state.filterGroupLookupTable = buildFilterGroupLookup(filterGroups);
  state.filterGroups = buildFilterGroups(filterGroups, state);
  for(var i = 0; i < state.filterGroups.length; i++) {
    const group = state.filterGroups[i];
    sortBy(group.values, 'order');
    for(var n = 0; n < group.values.length; n++) {
      const groupValue = group.values[n];
      if(groupValue.items && groupValue.items.length > 0) {
        sortBy(groupValue.items, 'order');
      }
    }
  }
  state.usedFilterGroups = buildFilterGroups(getUsedFilters(filterGroups, state.stones, state.usedFilterIds), state);
  
  return state;
}

function getUsedFilterIds(stones) {
  var usedFilterIds = _.uniq(_.flatMap(stones, s => _.map(s.filters, f => f.filterGroupValue_id)));
  usedFilterIds.sort((a, b) => {
    if(a > b) return 1;
    if(b > a) return -1;
    return 0;
  });
  
  return usedFilterIds;
}

function buildFilterGroupLookup(filterGroups) {
  let dict = [];
  for(let i = 0; i < filterGroups.length; i++) {
    let fg = filterGroups[i];
    dict.push({
      group: fg.name,
      values: _.map(fg.values, v => v.id)
    }); 
  }
  return dict;
}

function getUsedFilters(filterGroups, stones, usedFilterIds) {
  let newFilterGroups = [];
  for(var n = 0; n < filterGroups.length; n++) {
    newFilterGroups.push(filterGroups[n]);
    newFilterGroups[n].values = _.filter(filterGroups[n].values, v => (_.findIndex(usedFilterIds, id => id == v.id) >= 0));
  }
  return JSON.parse(JSON.stringify(newFilterGroups));
}

function buildFilterGroups(filterGroups, state) {
  let newFilterGroups = JSON.parse(JSON.stringify(filterGroups));
  for(let a = 0; a < filterGroups.length; a++) {
    let filterGroup = newFilterGroups[a];
    let newFilterGroupList = [];
    let childFilterGroups = [];
    for(let i = 0; i < filterGroup.values.length; i++) {
      let filterGroupValue = filterGroup.values[i];
      if(state.selectableFilterIds.indexOf(filterGroupValue.id) < 0) continue;
      if(filterGroupValue.parent_id || filterGroupValue.parentId)
        childFilterGroups.push(filterGroupValue);
      else
        newFilterGroupList.push(filterGroupValue);
    }
    for(let i = 0; i < childFilterGroups.length; i++) {
      let n = _.findIndex(newFilterGroupList, f => f.id == childFilterGroups[i].parent_id || f.id == childFilterGroups[i].parentId);
      if(n >= 0) {
        newFilterGroupList[n].items = newFilterGroupList[n].items || [JSON.parse(JSON.stringify(newFilterGroupList[n]))];
        newFilterGroupList[n].items.push(childFilterGroups[i]);
      }
    }
    newFilterGroups[a].values = JSON.parse(JSON.stringify(newFilterGroupList));
  }
  return newFilterGroups;
}

function setMaterialFilter(state, action) {
  const { item } = action.payload;
  let id = item.id;

  toggle(state.selectedFilters, id);
  return {...state};
}

function toggle(collection, item) {
  var idx = _.indexOf(collection, item);
  if(idx !== -1) {
    collection.splice(idx, 1);
  } else {
    collection.push(item);
  }
}

function addStoneFilter(state, filter, type) {
  let newState = {...state};
  let fg = _.first(newState.filterGroups.filter(fg => fg.name == type));
  if(type == 'Stone Color')
    fg.values.unshift(filter);
  else {
    if(filter.parentId) {
      let nfilter = _.first(fg.values.filter(v => v.id == filter.parentId));
      nfilter.items = nfilter.items || [];
      nfilter.items.unshift(filter);
    } else {
      fg.values.unshift(filter);
    }
  }
  _.first(newState.filterGroupLookupTable.filter(fglt => fglt.group == type)).values.push(filter.id);
  return newState;
}

export default function stonesV2Reducer(state = initialState, action) {
  switch (action.type) {
    case actionTypes.FETCH_STONES:
      return setStones(state, action);

    case actionTypes.FILTER_STONES_COLOR:
      return {...state, colorFilter: action.payload};

    case actionTypes.FILTER_STONES_MATERIAL:
      return {...state, materialFilter: action.payload};

    case actionTypes.FETCHED_STONES_FILTERS:
      return {...state, materialsFilters: [].concat(action.payload)};
    case actionTypes.SET_FILTER_STONES_MATERIAL:
      return setMaterialFilter(state, action);

    case actionTypes.ADD_STONE_FILTER:
      return addStoneFilter(state, action.payload.filter, action.payload.type);

    case actionTypes.STONE_CLEAR:
    case customerActionTypes.APP_SET_AS_CUSTOMER:
      return {  
        stones: [],
        fabricatorStones: [],
        masterStoneListIds: [],
        fabricatorCustomFilterIds: [],
        masterFilterIds: [],
        selectableFilterIds: [],
        filterGroupLookupTable: [],
        filterGroups: [],
        selectedFilters: [],
        usedFilterGroups: [],
        updates: [],
        usedFilterIds: []
      }

    case actionTypes.STONE_SUPPLIER_STONE_UPDATE_STORE_VALUE:
      let fabStones = [...state.fabricatorStones];
      let newState = {...state};
      for(var i = 0; i < fabStones.length; i++) {
        if(action.payload.stones.indexOf(fabStones[i].stone_id) >= 0) {
          fabStones[i][action.payload.field] = action.payload.value;
        }
      }
      newState.fabricatorStones = fabStones;
      return newState;

    default:
      return state;
  }
}
